// First-touch UTM lead attribution stored in localStorage for 30 days.
const STORAGE_KEY = 'lead_attribution';
const THIRTY_DAYS_MS = 30 * 24 * 60 * 60 * 1000;

// Capture utm_source/medium/campaign from the current URL on landing.
// Only writes when UTM params are present — a later UTM-less landing will NOT
// overwrite an existing stored value (first-touch preserved). A fresh landing
// WITH new UTM params does overwrite.
export function captureAttribution(search) {
  try {
    const qs = typeof search === 'string' ? search : window.location.search;
    const params = new URLSearchParams(qs);
    const utm_source = params.get('utm_source');
    const utm_medium = params.get('utm_medium');
    const utm_campaign = params.get('utm_campaign');

    if (!utm_source && !utm_medium && !utm_campaign) return; // no UTM → keep existing

    const record = {
      utm_source: utm_source || null,
      utm_medium: utm_medium || null,
      utm_campaign: utm_campaign || null,
      expires: Date.now() + THIRTY_DAYS_MS,
    };
    localStorage.setItem(STORAGE_KEY, JSON.stringify(record));
  } catch (e) {
    /* localStorage unavailable — no-op */
  }
}

// Read stored attribution, honoring the 30-day expiration. Returns null if none/expired.
export function getAttribution() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const rec = JSON.parse(raw);
    if (rec.expires && Date.now() > rec.expires) {
      localStorage.removeItem(STORAGE_KEY);
      return null;
    }
    return {
      utm_source: rec.utm_source || null,
      utm_medium: rec.utm_medium || null,
      utm_campaign: rec.utm_campaign || null,
    };
  } catch (e) {
    return null;
  }
}
